import { FormElementType, SignupForm } from "@redotech/redo-model/signup-form";
import { memo, NamedExoticComponent, useState } from "react";
import { Flex } from "../flex";
import { FormButton } from "./form-elements/form-button";
import { FormElementProps } from "./form-elements/index";
import { Input } from "./form-elements/input";
import { RichText } from "./form-elements/rich-text";

const elementComponents: Record<
  FormElementType,
  NamedExoticComponent<FormElementProps<any>>
> = {
  [FormElementType.INPUT]: Input,
  [FormElementType.RICH_TEXT]: RichText,
  [FormElementType.BUTTON]: FormButton,
};

export interface SignupFormProps {
  form: SignupForm;
  currentStep: number;
  onSubmitStep: (
    stepIndex: number,
    formData: Record<string, string>,
  ) => Promise<void>;
}

export const BaseSignupForm = memo(function BaseSignupForm({
  form,
  currentStep,
  onSubmitStep,
}: SignupFormProps) {
  const [submitting, setSubmitting] = useState(false);
  return (
    <div>
      <form
        onSubmit={async (e) => {
          setSubmitting(true);
          e.preventDefault();
          const formData = new FormData(e.currentTarget);
          const transformedData: Record<string, string> = {};
          formData.forEach((value, key) => {
            transformedData[key] = value as string;
          });
          try {
            await onSubmitStep(currentStep, transformedData);
            setSubmitting(false);
          } catch (e) {
            console.error(e);
            setSubmitting(false);
          }
        }}
      >
        <Flex dir="column" gap="xl" py="xl">
          {form.steps[currentStep].elements.map((element, index) => {
            const ElementComponent = elementComponents[element.type];
            return (
              <div key={index}>
                <ElementComponent
                  element={element}
                  form={form}
                  submitting={submitting}
                />
              </div>
            );
          })}
        </Flex>
      </form>
    </div>
  );
});
